/* ================================================
   Valentina Linens – Best Sellers Parallax v1
   Cards float up + depth-shift on scroll
   ================================================ */

(function () {
  'use strict';

  const PARALLAX_SPEED = 0.06;   // how much depth shift (lower = subtler)
  const FLOAT_SPEED    = 0.35;   // how fast cards float up into view
  const TILT_MAX       = 8;      // max degrees of 3D tilt on scroll (degrees)

  function initParallax() {
    const grids = document.querySelectorAll('.collection .product-grid');
    if (!grids.length) return;

    const cards = [];
    grids.forEach((grid) => {
      grid.querySelectorAll('.grid__item').forEach((card, i) => {
        cards.push({
          el: card,
          index: i,
          offsetY: 0,
          targetY: 0,
          visible: false,
        });
      });
    });

    if (!cards.length) return;

    // Intersection Observer — triggers float-in animation
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = cards.find((c) => c.el === entry.target);
          if (!card) return;
          if (entry.isIntersecting) {
            card.visible = true;
            card.el.classList.add('parallax-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    cards.forEach((c) => observer.observe(c.el));

    // Scroll handler — applies parallax depth per card
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateCards);
        ticking = true;
      }
    }

    function updateCards() {
      const scrollY = window.scrollY;
      const viewH   = window.innerHeight;

      cards.forEach((card, i) => {
        if (!card.visible) return;

        const rect      = card.el.getBoundingClientRect();
        const cardCenter = rect.top + rect.height / 2;
        const fromCenter = (viewH / 2 - cardCenter) / viewH; // -0.5 to 0.5

        // Vertical parallax float — odd/even cards move at slightly different speeds
        const direction = i % 2 === 0 ? 1 : -1;
        const translateY = fromCenter * viewH * PARALLAX_SPEED * direction;

        // Subtle 3D tilt based on scroll position
        const tiltX = fromCenter * TILT_MAX;

        // Scale: cards grow very slightly as they approach center
        const scale = 1 + Math.abs(fromCenter) * 0.015;

        card.el.style.transform = `
          translateY(${translateY}px)
          rotateX(${tiltX * 0.5}deg)
          scale(${scale})
        `;
      });

      ticking = false;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateCards(); // run once on load
  }

  // Init after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();